// Auto-generated by scripts/generate-registry.mjs from packages/modules/uach_logo_clicker/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const uach_logo_clicker: ModuleSchema = {
  "id": "uach_logo_clicker",
  "uniqueId": "B3D_HRIAE",
  "createdAt": "2026-10-22T10:58:28.136Z",
  "updatedAt": "2026-10-22T11:31:34.367Z",
  "label": "UAH Clicker Round",
  "description": "Round MX clicker with the raised University of Architecture Ho Chi Minh City logo and 50th-anniversary body relief",
  "category": "fidget",
  "tags": [
    "uach",
    "logo",
    "clicker",
    "mx-switch",
    "round",
    "anniversary"
  ],
  "sliders": [
    {
      "key": "diameter",
      "label": "Đường kính",
      "min": 25,
      "max": 50,
      "default": 40,
      "step": 1,
      "unit": "mm",
      "targetGroupIds": [
        0,
        1,
        2,
        3,
        4,
        5
      ],
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "round_base",
      "label": "Clicker Base and Hanger",
      "default": "#9CA3AF",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "round_switch",
      "label": "MX Switch Simulation",
      "default": "#9CA3AF",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "round_cap",
      "label": "Round Keycap",
      "default": "#FFFFFF",
      "targetGroupIds": [
        2
      ]
    },
    {
      "key": "round_logo",
      "label": "Raised UAH Logo",
      "default": "#9CA3AF",
      "targetGroupIds": [
        3
      ]
    },
    {
      "key": "round_years",
      "label": "Raised 1976-2026",
      "default": "#FFFFFF",
      "targetGroupIds": [
        4
      ]
    },
    {
      "key": "round_50",
      "label": "Raised 50",
      "default": "#FFFFFF",
      "targetGroupIds": [
        5
      ]
    }
  ],
  "objects": [
    {
      "id": "clicker_base",
      "label": "Clicker Base and Hanger",
      "name": "Clicker Base and Hanger",
      "color": "#9CA3AF",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "round_base",
          "label": "Clicker Base and Hanger",
          "name": "Clicker Base and Hanger",
          "groupId": 0,
          "colorKey": "round_base",
          "defaultColor": "#9CA3AF",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    },
    {
      "id": "mx_switch",
      "label": "MX Switch",
      "name": "MX Switch",
      "color": "#9CA3AF",
      "assembled_z_offset": 0,
      "exploded_z_offset": 18,
      "parts": [
        {
          "id": "round_switch",
          "label": "MX Switch Simulation",
          "name": "MX Switch Simulation",
          "groupId": 1,
          "colorKey": "round_switch",
          "defaultColor": "#9CA3AF",
          "assembled_z_offset": 0,
          "exploded_z_offset": 18,
          "export_stl": true
        }
      ]
    },
    {
      "id": "keycap",
      "label": "Round White Keycap",
      "name": "Round White Keycap",
      "color": "#FFFFFF",
      "assembled_z_offset": 0,
      "exploded_z_offset": 32,
      "parts": [
        {
          "id": "round_cap",
          "label": "Round Keycap",
          "name": "Round Keycap",
          "groupId": 2,
          "colorKey": "round_cap",
          "defaultColor": "#FFFFFF",
          "assembled_z_offset": 0,
          "exploded_z_offset": 32,
          "export_stl": true
        }
      ]
    },
    {
      "id": "uach_logo",
      "label": "Raised UAH Logo",
      "name": "Raised UAH Logo",
      "color": "#9CA3AF",
      "assembled_z_offset": 0,
      "exploded_z_offset": 42,
      "parts": [
        {
          "id": "round_logo",
          "label": "Raised UAH Logo",
          "name": "Raised UAH Logo",
          "groupId": 3,
          "colorKey": "round_logo",
          "defaultColor": "#9CA3AF",
          "assembled_z_offset": 0,
          "exploded_z_offset": 42,
          "export_stl": true
        }
      ]
    },
    {
      "id": "anniversary_years",
      "label": "Raised 1976-2026",
      "name": "Raised 1976-2026",
      "color": "#FFFFFF",
      "assembled_z_offset": 0,
      "exploded_z_offset": 8,
      "parts": [
        {
          "id": "round_years",
          "label": "Raised 1976-2026",
          "name": "Raised 1976-2026",
          "groupId": 4,
          "colorKey": "round_years",
          "defaultColor": "#FFFFFF",
          "assembled_z_offset": 0,
          "exploded_z_offset": 8,
          "export_stl": true
        }
      ]
    },
    {
      "id": "anniversary_50",
      "label": "Raised 50",
      "name": "Raised 50",
      "color": "#FFFFFF",
      "assembled_z_offset": 0,
      "exploded_z_offset": 12,
      "parts": [
        {
          "id": "round_50",
          "label": "Raised 50",
          "name": "Raised 50",
          "groupId": 5,
          "colorKey": "round_50",
          "defaultColor": "#FFFFFF",
          "assembled_z_offset": 0,
          "exploded_z_offset": 12,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Full UAH Clicker"
    },
    {
      "id": "0",
      "label": "Download STL - Clicker Base"
    },
    {
      "id": "1",
      "label": "Download STL - MX Switch"
    },
    {
      "id": "2",
      "label": "Download STL - Keycap"
    },
    {
      "id": "3",
      "label": "Download STL - UAH Logo"
    },
    {
      "id": "4",
      "label": "Download STL - Raised 1976-2026"
    },
    {
      "id": "5",
      "label": "Download STL - Raised 50"
    }
  ]
};
